export const APIENDPOINT = "https://schoolapi.namtechsolutions.in"